/**
 * Help & docs: open state and the deep-link target.
 *
 * `openHelp('variables#popout')` can be called from anywhere — the rail "?",
 * the onboarding's last step, or a small "?" beside a feature later. The
 * target is `<page-id>` or `<page-id>#<heading-id>` (DOCS_CONTRACT: page and
 * heading ids are stable because deep links depend on them).
 */
import { create } from 'zustand';

export function parseHelpTarget(target) {
  if (!target || typeof target !== 'string') return { pageId: null, headingId: null };
  const [pageId, headingId] = target.split('#');
  return { pageId: pageId || null, headingId: headingId || null };
}

export const useHelpStore = create((set) => ({
  open: false,
  pageId: null,
  headingId: null,
  // Bumped per openHelp() so re-opening the SAME target scrolls again.
  nonce: 0,
  openHelp: (target) =>
    set((s) => ({ open: true, ...parseHelpTarget(target), nonce: s.nonce + 1 })),
  closeHelp: () => set({ open: false }),
}));

export function openHelp(target) {
  useHelpStore.getState().openHelp(target);
}

export function closeHelp() {
  useHelpStore.getState().closeHelp();
}
